"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
// import { TopWin } from '@beem/softgaming-api-client'
// import { useSelector } from 'react-redux'
// import { getTopWinnersFirst20 } from './selectors'
var react_1 = require("react");
var ramda_1 = require("ramda");
var useGeneratedTopWinners = function () {
    // const topWinners = useSelector(getTopWinnersFirst20)
    var fakeTopWInners = (0, react_1.useMemo)(function () {
        return [
            {
                Amount: 65275.0,
                AmountEUR: 65275.0,
                CountryID: '49',
                CountryIso2: 'de',
                CountryIso3: 'deu',
                Currency: 'EUR',
                CurrencyID: 0,
                Date: '2022-06-07 10:15:23',
                Email: 'jacker*****@gmail.cn',
                ExtLogin: '',
                GameCode: 'bonanzaDesktop',
                GameDescription: '',
                GameID: 2025975,
                GameName: 'Bonanza',
                ID: '27c554c1-01e0-4d08-a093-c3d201903d9c',
                Image: 'https://agstatic.com/games/mg/bonanza_megaways.jpg',
                Merchant: 'BGaming',
                ScreenName: 'Jacker',
                Url: '997/bonanzaDesktop',
                UserID: '453515958',
            },
            {
                Amount: 56768.0,
                AmountEUR: 56768.0,
                CountryID: '49',
                CountryIso2: 'de',
                CountryIso3: 'deu',
                Currency: 'EUR',
                CurrencyID: 0,
                Date: '2022-06-07 10:15:23',
                Email: 'dreamflip*****@gmail.cn',
                ExtLogin: '',
                GameCode: 'FruitMillion',
                GameDescription: '',
                GameID: 2025975,
                GameName: 'Fruit Million',
                ID: '0ab95de7-5962-414d-9e29-25c7a6d55e3b',
                Image: 'https://agstatic.com/games/bgaming/fruit_million_summer_edition.jpg',
                Merchant: 'BGaming',
                ScreenName: 'Dreamflip',
                Url: '901/FruitMillion',
                UserID: '453515958',
            },
            {
                Amount: 46365.0,
                AmountEUR: 46365.0,
                CountryID: '49',
                CountryIso2: 'de',
                CountryIso3: 'deu',
                Currency: 'EUR',
                CurrencyID: 0,
                Date: '2022-06-07 10:15:23',
                Email: 'misterfister*****@gmail.cn',
                ExtLogin: '',
                GameCode: '10122',
                GameDescription: '',
                GameID: 2025975,
                GameName: 'Multifly',
                ID: '95909d23-3511-417c-b14b-220ea02bf564',
                Image: 'https://agstatic.com/games/yggdrasil/multi_fly.jpg',
                Merchant: 'BGaming',
                ScreenName: 'misterfister',
                Url: '953/10122',
                UserID: '453515958',
            },
            {
                Amount: 30093.0,
                AmountEUR: 30093.0,
                CountryID: '49',
                CountryIso2: 'de',
                CountryIso3: 'deu',
                Currency: 'EUR',
                CurrencyID: 0,
                Date: '2022-06-07 10:15:23',
                Email: 'markus*****@gmail.cn',
                ExtLogin: '',
                GameCode: 'FruitMillion',
                GameDescription: '',
                GameID: 2025975,
                GameName: 'Fruit Million',
                ID: '0ab95de7-5962-414d-9e29-25c7a6d55e3b',
                Image: 'https://agstatic.com/games/bgaming/fruit_million_summer_edition.jpg',
                Merchant: 'BGaming',
                ScreenName: 'Markus',
                Url: '901/FruitMillion',
                UserID: '453515958',
            },
            {
                Amount: 28004.0,
                AmountEUR: 28004.0,
                CountryID: '49',
                CountryIso2: 'de',
                CountryIso3: 'deu',
                Currency: 'EUR',
                CurrencyID: 0,
                Date: '2022-06-07 10:15:23',
                Email: 'thorsten*****@gmail.cn',
                ExtLogin: '',
                GameCode: 'dangerHighVoltageDesktop',
                GameDescription: '',
                GameID: 2025975,
                GameName: 'Danger! High Voltage',
                ID: '899f770f-3092-471d-afb3-f57e47e0c80b',
                Image: 'https://agstatic.com/games/mg/danger_high_voltage.jpg',
                Merchant: 'BGaming',
                ScreenName: 'Thorsten',
                Url: '997/dangerHighVoltageDesktop',
                UserID: '453515958',
            },
        ];
    }, []);
    return (0, react_1.useMemo)(function () {
        //@ts-ignore
        return (0, ramda_1.sortWith)([(0, ramda_1.descend)((0, ramda_1.prop)('Amount'))])(__spreadArray(__spreadArray([], fakeTopWInners, true), [], false));
    }, [fakeTopWInners]);
};
exports.default = useGeneratedTopWinners;
